/**
 * Viewport scaling (EXT-624). The TV layout is authored in absolute px
 * against a 1920-wide design (getScaledValue is ×1 on the web build), so a
 * smaller viewport — e.g. the native TV shell's 1280×720 iframe — rendered
 * oversized, off-center items. Zooming the document by viewport/1920 keeps
 * the 1920 composition on any width.
 */
export const DESIGN_WIDTH = 1920;

export function computeScale(viewportWidth: number, designWidth = DESIGN_WIDTH): number {
  if (!Number.isFinite(viewportWidth) || viewportWidth <= 0) return 1;
  return viewportWidth / designWidth;
}

export function applyViewportScale(): () => void {
  const update = () => {
    document.documentElement.style.zoom = String(computeScale(window.innerWidth));
  };
  update();
  window.addEventListener('resize', update);
  return () => {
    window.removeEventListener('resize', update);
    document.documentElement.style.zoom = '';
  };
}
